import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PartnerWithEduStrategix() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="4004" id="eligibility-form" ref={ref} className="bg-background bg-[url('https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&q=80')] bg-cover bg-fixed bg-center bg-blend-overlay py-24 px-6 md:px-12 lg:px-24 flex flex-col items-center justify-center text-center">
      <div className={cn("w-full max-w-4xl mx-auto mb-16 transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        
      </div>
      <div className={cn("max-w-4xl mx-auto transition-all duration-700 ease-out transform bg-white/40 backdrop-blur-md border border-white/20 shadow-2xl rounded-2xl p-8 md:p-12", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <h2 className="font-serif font-bold text-4xl md:text-5xl lg:text-6xl text-primary mb-6 leading-[1.1]">
          Take the First Step Toward Freedom
        </h2>

        <p className="font-default text-[20px] md:text-[24px] leading-relaxed text-muted-foreground mb-10 max-w-2xl mx-auto">
          Complete our secure assessment to see if your timeshare qualifies for a legal exit and regain control of your financial future.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild className={cn("h-auto px-8 py-4 text-lg font-bold rounded-lg uppercase", "bg-secondary text-secondary-foreground", "hover:bg-secondary/90", "transition-all duration-[120ms] ease-out", "hover:-translate-y-[2px] hover:shadow-lg shadow-md border-b-2 border-black/20")}>
            <Link to="#eligibility-form">Check Eligibility</Link>
          </Button>

          <Button asChild variant="outline" className={cn("h-auto px-8 py-4 text-lg font-bold rounded-lg uppercase", "bg-transparent border-2 border-secondary text-secondary", "hover:bg-secondary/10 hover:text-secondary hover:border-secondary", "transition-all duration-[120ms] ease-out", "hover:-translate-y-[2px] hover:shadow-lg shadow-none")}>
            <Link to="#">View FAQs</Link>
          </Button>
        </div>
      </div>
    </section>;
}